import { OrderedMap } from 'immutable';
import OnlineHomeworkContent from './model';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'lessonNumber':
      return [key, Number.parseInt(val, 10)];
    case 'unitId':
      return [key, `${val}`];
    case 'contentItems':
      return [key, val.reduce((map, item) =>
        map.set(`${item.name}`, new OnlineHomeworkContent.Item(item)), new OrderedMap())];
    default:
      return [key, val];
  }
};

const create = (data) =>
  new OnlineHomeworkContent(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/OnlineHomework/Content/create.js